import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgMenuHambFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 4a2 2 0 0 1 .15 3.995L18 8H6a2 2 0 0 1-.15-3.995L6 4h12Zm0 6a2 2 0 0 1 .15 3.995L18 14H6a2 2 0 0 1-.15-3.995L6 10h12Zm2 8a2 2 0 0 0-2-2H6l-.15.006A2 2 0 0 0 6 20h12l.15-.006A2 2 0 0 0 20 18Z", fill: color }));
};
export default factorySvgIcon(SvgMenuHambFilled);
//# sourceMappingURL=SvgMenuHambFilled.js.map